import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagAcumuladoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagAcumulado'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagAcumulado' label='Acumulado' />}
    </Field>
  )
}

export default React.memo(FlagAcumuladoFormGroup)
